import $ from 'jquery'

$(function() {

    $('.accordion-header').click(function() {
        // Toggle the accordion content
        $(this).next('.accordion-panel').slideToggle();
        
        // Toggle the accordion title active class
        $(this).toggleClass('active');
        
        // Close other accordion items
        $('.accordion-header').not(this).removeClass('active');
        $('.accordion-panel').not($(this).next('.accordion-panel')).slideUp();
    });
    
    $('.accordion-header').first().click();
});


// WEBPACK FOOTER //
// ./resources/assets/js/partials/accordion.js